<template>
    <div class="d-inline-flex">
        <button 
            class="btn btn-link btn-sm"
            @click="decrease()"
            type="button"
            :disabled="disable || myCount <= min">
            <i class="fas fa-minus-circle"></i>
        </button>
        <span class="counter"> {{myCount}} </span>
        <button 
            class="btn btn-link btn-sm"
            @click="increase()"
            type="button"
            :disabled="disable || disableMax || myCount >= max">
            <i class="fas fa-plus-circle"></i>
        </button>
    </div>
</template>
<script>
export default {
    data(){
        return {myCount:0}
    },
    props:{
        count : { type: Number },
        min : { type: Number, default: 0 },
        max : { type: Number, default: 10000 },
        disable : { type:Boolean, default: false },
        disableMax : { type:Boolean, default: false }        
    },
    watch:{
        count(){
            this.myCount = this.count
        }
    },
    mounted(){
        this.$nextTick(() => {
            this.myCount = this.count
        })  
    },
    methods:{
        increase(){
          //  this.myCount++;
            this.$emit('on-count', this.count+1)//this.myCount);
        },
        decrease(){
          //  this.myCount--;
            this.$emit('on-count', this.count-1)//this.myCount);            
        },
        getMyCount(){
            return this.myCount;
        }
    }
}
</script>
<style scoped>
.btn{
    height: fit-content;
}
</style>